import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { Badge } from "../generic/badge/Badge";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { getResourceIcon } from "../generic/icon/getResourceIcon";
import { Icon } from "../generic/icon/Icon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
import { TextLoca } from "../generic/text/TextLoca";
export var DoghouseRewardListItem = function (_a) {
    var resource = _a.resource;
    var icon = getResourceIcon(resource);
    var iconStyle = "pos-rel reward-list-item-icon " + IdStyles.IconSmall;
    return (React.createElement("div", { className: IdStyles.RewardListEntryMid + " reward-list-item" },
        React.createElement(Icon, { icon: icon, styleId: iconStyle },
            React.createElement(Badge, { position: IdBadgePosition.Bottom },
                React.createElement(NumberFormat, { amount: resource.dropPercentage, format: TypeNumberFormat.Percent, className: IdStyles.TextSmallBoldSecondaryOutline }))),
        React.createElement(TextLoca, { id: resource.locaKey, className: IdStyles.TextNormal + " reward-list-item-label" })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/DoghouseRewardListItem.tsx
// module id = 2819
// module chunks = 3